import { faWarning } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import NoticeBox from '@components/NoticeBox'

type SimpleNoticeBoxProps = {
title: string,
paragraph?: string,
}

const SimpleNoticeBox = (props: SimpleNoticeBoxProps) => {
  const {
    title,
    paragraph,
  } = props
  return (
    <NoticeBox
      icon={<FontAwesomeIcon icon={faWarning} />}
    >
      <NoticeBox.Title>
        {title}
      </NoticeBox.Title>

      <NoticeBox.Paragraph>
        {paragraph}
      </NoticeBox.Paragraph>
    </NoticeBox>
  )
}

export default SimpleNoticeBox
